import React, { useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import HelpModal from './HelpModal';
import './HelpButton.css';

/**
 * Componente de botão de ajuda com modal
 * @param {Object} props - Propriedades do componente
 * @param {string} props.title - Título da ajuda
 * @param {ReactNode} props.children - Conteúdo da ajuda (pode ser passado como children)
 * @param {ReactNode} props.content - Conteúdo da ajuda (alternativa ao children)
 * @param {string} props.icon - Ícone para o botão (opcional)
 * @param {string} props.className - Classes CSS adicionais (opcional)
 * @param {string} props.modalIcon - Ícone para o modal (opcional)
 * @param {string} props.position - Posição do botão (opcional)
 */
const HelpButton = ({ 
  title = "Ajuda", 
  children, 
  content, 
  icon = "?", 
  className = "",
  modalIcon = "💡",
  position = "default"
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  // Usando useCallback para evitar recriações desnecessárias das funções
  const openModal = useCallback((e) => {
    // Impedir propagação e comportamento padrão
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setIsModalOpen(true);
  }, []);
  
  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);
  
  // Permite que o conteúdo seja passado via prop content ou como children
  const modalContent = content || children;
  
  // Renderiza apenas o botão no fluxo normal do DOM
  return (
    <>
      <button 
        className={`help-button ${position} ${className}`}
        onClick={openModal}
        onMouseDown={(e) => {
          // Também previne problemas com eventos de mouse
          e.preventDefault();
          e.stopPropagation();
        }}
        aria-label={`Abrir ajuda sobre ${title}`}
        title={`Ajuda sobre ${title}`}
      >
        <span className="help-button-icon">{icon}</span>
      </button>
      
      {/* Renderiza o modal diretamente no body usando portal, fora da hierarquia DOM atual */}
      {isModalOpen && ReactDOM.createPortal(
        <HelpModal
          isOpen={true}
          onClose={closeModal}
          title={title}
          icon={modalIcon}
        >
          {modalContent}
        </HelpModal>,
        document.body
      )}
    </>
  );
};

export default HelpButton;
